import React from "react";
import { NavLink } from "react-router-dom";
import { Auth } from "redux-server-connection";

import "./styles.css";

const Render = (props, context) => {
  const user = Auth.getUser();

  return (
    <ul className="tabs horizontalCenter clearfix">
      <li>
        <NavLink to="/objetivos" className="avenirM" activeClassName="current">
          Objetivos
        </NavLink>
      </li>
      {user && user.type !== 2 && (
        <li>
          <NavLink
            to="/avances"
            className="avenirM"
            activeClassName="current"
          >
            Avances
          </NavLink>
        </li>
      )}
      {/* user && user.type !== 3 && ( */}
        <li>
          <NavLink to="/capacitaciones" className="avenirM" activeClassName="current">
            Capacitaciones
          </NavLink>
        </li>
      {/* ) */}
      {/* user && user.type !== 3 && ( */}
        <li>
          <NavLink to="/trivias" className="avenirM" activeClassName="current">
            Trivias
          </NavLink>
        </li>
      {/* ) */}
    </ul>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/components/DesafiosTabs/Render.js